// Floor plan room definitions traced from MTL Cannabis X architectural PDF
// Coordinates are in pixel units matching the PDF image (2384 x 3370)
// Each room has: id, label, zone, x, y, w, h

export const floorplanRooms = [
  {
    id: "VEG-2",
    label: "Veg #2",
    zone: "veg",
    x: 702,
    y: 563,
    w: 423,
    h: 110
  },
  {
    id: "VEG-1",
    label: "Veg #1",
    zone: "veg",
    x: 706,
    y: 674,
    w: 418,
    h: 109
  },
  {
    id: "VEG-4",
    label: "Veg #4",
    zone: "veg",
    x: 1172,
    y: 567,
    w: 440,
    h: 107
  },
  {
    id: "VEG-3",
    label: "Veg #3",
    zone: "veg",
    x: 1172,
    y: 674,
    w: 437,
    h: 114
  },
  {
    id: "DRY-5",
    label: "Dry #5",
    zone: "dry",
    x: 1676,
    y: 566,
    w: 416,
    h: 118
  },
  {
    id: "DRY-4",
    label: "Dry #4",
    zone: "dry",
    x: 1676,
    y: 683,
    w: 417,
    h: 117
  },
  {
    id: "F9",
    label: "Flower #9",
    zone: "flower",
    x: 707,
    y: 790,
    w: 412,
    h: 289
  },
  {
    id: "F14",
    label: "Flower #14",
    zone: "flower",
    x: 1176,
    y: 790,
    w: 435,
    h: 293
  },
  {
    id: "F18",
    label: "Flower #18",
    zone: "flower",
    x: 1945,
    y: 797,
    w: 284,
    h: 426
  },
  {
    id: "F8",
    label: "Flower #8",
    zone: "flower",
    x: 717,
    y: 1086,
    w: 405,
    h: 281
  },
  {
    id: "F17",
    label: "Flower #17",
    zone: "flower",
    x: 1663,
    y: 798,
    w: 276,
    h: 429
  },
  {
    id: "F13",
    label: "Flower #13",
    zone: "flower",
    x: 1170,
    y: 1084,
    w: 436,
    h: 287
  },
  {
    id: "CLONE-2",
    label: "Clone #2",
    zone: "clone",
    x: 147,
    y: 1664,
    w: 132,
    h: 84
  },
  {
    id: "CLONE-1",
    label: "Clone #1",
    zone: "clone",
    x: 147,
    y: 1579,
    w: 135,
    h: 80
  },
  {
    id: "CLONE-4",
    label: "Clone #4",
    zone: "clone",
    x: 151,
    y: 1837,
    w: 132,
    h: 83
  },
  {
    id: "WASH",
    label: "Wash",
    zone: "processing",
    x: 156,
    y: 1931,
    w: 124,
    h: 151
  },
  {
    id: "SHIP-1",
    label: "Shipping & Receiving",
    zone: "logistics",
    x: 271,
    y: 1094,
    w: 228,
    h: 69
  },
  {
    id: "SECURE-STOR",
    label: "Secure Storage",
    zone: "logistics",
    x: 323,
    y: 1848,
    w: 372,
    h: 282
  },
  {
    id: "BULK-STOR",
    label: "Bulk Storage",
    zone: "logistics",
    x: 153,
    y: 1358,
    w: 132,
    h: 131
  },
  {
    id: "TRIM-2",
    label: "Trim #2",
    zone: "processing",
    x: 332,
    y: 1692,
    w: 245,
    h: 148
  },
  {
    id: "TRIM-1",
    label: "Trim #1",
    zone: "processing",
    x: 329,
    y: 1544,
    w: 250,
    h: 144
  },
  {
    id: "RETAIL-PKG-3",
    label: "Retail Pkg #3",
    zone: "processing",
    x: 541,
    y: 2284,
    w: 152,
    h: 142
  },
  {
    id: "RETAIL-PKG-2",
    label: "Retail Pkg #2",
    zone: "processing",
    x: 334,
    y: 2281,
    w: 203,
    h: 142
  },
  {
    id: "RETAIL-PKG-1",
    label: "Retail Pkg #1",
    zone: "processing",
    x: 335,
    y: 2142,
    w: 355,
    h: 132
  },
  {
    id: "RETAIL-PREP",
    label: "Retail Prep",
    zone: "processing",
    x: 158,
    y: 2286,
    w: 123,
    h: 278
  },
  {
    id: "DRY-PE",
    label: "Dry P.E.",
    zone: "dry",
    x: 1668,
    y: 1719,
    w: 301,
    h: 131
  },
  {
    id: "PRE-VEG",
    label: "Pre Veg",
    zone: "veg",
    x: 1098,
    y: 2476,
    w: 265,
    h: 155
  },
  {
    id: "F6",
    label: "Flower #6",
    zone: "flower",
    x: 715,
    y: 1844,
    w: 402,
    h: 278
  },
  {
    id: "F5",
    label: "Flower #5",
    zone: "flower",
    x: 718,
    y: 2134,
    w: 403,
    h: 283
  },
  {
    id: "F15",
    label: "Flower #15",
    zone: "flower",
    x: 1665,
    y: 1295,
    w: 284,
    h: 420
  },
  {
    id: "F16",
    label: "Flower #16",
    zone: "flower",
    x: 1954,
    y: 1294,
    w: 266,
    h: 423
  },
  {
    id: "DRY-2",
    label: "Dry #2",
    zone: "dry",
    x: 1173,
    y: 1419,
    w: 432,
    h: 122
  },
  {
    id: "F7",
    label: "Flower #7",
    zone: "flower",
    x: 710,
    y: 1549,
    w: 411,
    h: 282
  },
  {
    id: "DRY-1",
    label: "Dry #1",
    zone: "dry",
    x: 753,
    y: 1421,
    w: 368,
    h: 118
  },
  {
    id: "SHIP-2",
    label: "Shipping & Receiving #2",
    zone: "logistics",
    x: 314,
    y: 1223,
    w: 204,
    h: 82
  },
  {
    id: "F10",
    label: "Flower #10",
    zone: "flower",
    x: 1177,
    y: 2136,
    w: 425,
    h: 288
  },
  {
    id: "F11",
    label: "Flower #11",
    zone: "flower",
    x: 1174,
    y: 1833,
    w: 428,
    h: 286
  },
  {
    id: "FLOWER-12",
    label: "Flower #12",
    zone: "flower",
    x: 1176,
    y: 1549,
    w: 426,
    h: 285
  }
];

export const zoneColors = {
  flower:     { fill: "#e8f5e9", stroke: "#2e7d32", hover: "#c8e6c9", text: "#1b5e20" },
  veg:        { fill: "#e3f2fd", stroke: "#1565c0", hover: "#bbdefb", text: "#0d47a1" },
  dry:        { fill: "#fff3e0", stroke: "#e65100", hover: "#ffe0b2", text: "#bf360c" },
  clone:      { fill: "#f3e5f5", stroke: "#7b1fa2", hover: "#e1bee7", text: "#4a148c" },
  processing: { fill: "#fce4ec", stroke: "#c62828", hover: "#f8bbd0", text: "#b71c1c" },
  utility:    { fill: "#f5f5f5", stroke: "#616161", hover: "#e0e0e0", text: "#424242" },
  logistics:  { fill: "#fff8e1", stroke: "#f9a825", hover: "#fff9c4", text: "#f57f17" },
  admin:      { fill: "#efebe9", stroke: "#795548", hover: "#d7ccc8", text: "#4e342e" },
};

// Zone labels for legend
export const zoneLabels = {
  flower: "Flower Rooms",
  veg: "Veg Rooms",
  dry: "Dry Rooms",
  clone: "Clone Rooms",
  processing: "Processing",
  utility: "Utility / Infrastructure",
  logistics: "Storage & Shipping",
  admin: "Admin / Offices",
};
